'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipRegistrationEventAction = exports.SeasonalEventAction = exports.QuickDepositEventAction = exports.WithdrawalEventAction = exports.DepositEventAction = exports.RegisterEventAction = exports.GameEventAction = exports.UserBalanceEventAction = exports.UserActivityAction = exports.TrackEventCategory = exports.TrackEvent = void 0;
var TrackEvent;
(function (TrackEvent) {
    TrackEvent["USER_ACTIVITY"] = "Wand.userActivity";
    TrackEvent["SEARCH"] = "Wand.search";
    TrackEvent["BALANCE"] = "Wand.balance";
    TrackEvent["GAME"] = "Wand.game";
    TrackEvent["GAME_CATEGORY"] = "Wand.gameCategory";
    TrackEvent["REGISTRATION"] = "Wand.registration";
    TrackEvent["DEPOSIT"] = "Wand.deposit";
    TrackEvent["WITHDRAWAL"] = "Wand.withdrawal";
    TrackEvent["KYC"] = "Wand.KYC";
    TrackEvent["RG_QUESTIONNAIRE"] = "Wand.rgquestionnaire";
    TrackEvent["SEASONAL_EVENT"] = "Wand.seasonalEvent";
    TrackEvent["MEMBERSHIP_REGISTRATION"] = "Wand.membershipRegistration";
    TrackEvent["REGISTER_FLOW"] = "Wand.registerFlow";
    TrackEvent["REGISTER_CLOSED"] = "Wand.registerClosed";
    TrackEvent["REGISTER_RESEND_LINK"] = "Wand.resendLink";
    TrackEvent["REGISTER_ATTEMPT"] = "Wand.registerAttempt";
    TrackEvent["REGISTER_SUBMITTED_AND_ACCEPTED"] = "Wand.registerSubmittedAndAccepted";
    TrackEvent["REGISTER_CONFIRMED_AND_ACTIVATED"] = "Wand.registerConfirmedAndActivated";
    TrackEvent["UPDATE_PROFILE"] = "Wand.profile_update";
})(TrackEvent = exports.TrackEvent || (exports.TrackEvent = {}));
var TrackEventCategory;
(function (TrackEventCategory) {
    // User Activity
    TrackEventCategory["LOGIN"] = "Login";
    TrackEventCategory["PAGE_VIEW"] = "pageView";
    TrackEventCategory["SELF_EXCLUSION"] = "selfExclusion";
    TrackEventCategory["COOKIE_CONSENT"] = "cookieConsent";
    // Customer Balance
    TrackEventCategory["BALANCE"] = "Balance";
    // Games
    TrackEventCategory["LOBBY"] = "Lobby";
    TrackEventCategory["CASINO"] = "Casino";
    TrackEventCategory["LIVE_CASINO"] = "Live Casino";
    // Registration
    TrackEventCategory["REGISTRATION"] = "Registration";
    // Cashier
    TrackEventCategory["DEPOSIT"] = "Deposit";
    TrackEventCategory["WITHDRAWAL"] = "Withdrawal";
    TrackEventCategory["QUICK_DEPOSIT"] = "QuickDeposit";
    // Search
    TrackEventCategory["SEARCH"] = "Search";
    // KYC
    TrackEventCategory["UPLOAD_DOCUMENT"] = "uploadKycDocument";
    // RG Questionnaire
    TrackEventCategory["RG_QUESTIONNAIRE"] = "RGQuestionnaire";
    // Seasonal Event
    TrackEventCategory["SEASONAL_EVENT"] = "Seasonal Event";
    //Membership Registration
    TrackEventCategory["MEMBERSHIP_REGISTRATION"] = "membershipRegistration";
    // Terms
    TrackEventCategory["TERMS"] = "terms";
    TrackEventCategory["PROFILE_UPDATE"] = "Profile_update";
})(TrackEventCategory = exports.TrackEventCategory || (exports.TrackEventCategory = {}));
/*
 * User Activity Events
 */
var UserActivityAction;
(function (UserActivityAction) {
    UserActivityAction["LOGGED_IN"] = "loggedIn";
    UserActivityAction["LOGIN_FAILED"] = "failed";
    UserActivityAction["FIRST_LOGIN"] = "firstLogin";
    UserActivityAction["LOGGED_OUT"] = "loggedOut";
    UserActivityAction["COOKIES_ACCEPTED"] = "accepted";
    UserActivityAction["COOKIES_REJECTED"] = "rejected";
})(UserActivityAction = exports.UserActivityAction || (exports.UserActivityAction = {}));
/*
 * Customer Balance Events
 */
var UserBalanceEventAction;
(function (UserBalanceEventAction) {
    // Balance < 5 eur/50 sek etc
    UserBalanceEventAction["NEAR_ZERO"] = "Near Zero";
    // Balance === 0
    UserBalanceEventAction["ZERO"] = "Zero";
})(UserBalanceEventAction = exports.UserBalanceEventAction || (exports.UserBalanceEventAction = {}));
/*
 * Games Events
 */
var GameEventAction;
(function (GameEventAction) {
    GameEventAction["REAL_PLAY"] = "Play";
    GameEventAction["FREE_PLAY"] = "Play for free";
    GameEventAction["END_PLAY"] = "Stop";
})(GameEventAction = exports.GameEventAction || (exports.GameEventAction = {}));
var RegisterEventAction;
(function (RegisterEventAction) {
    RegisterEventAction["CLOSE"] = "Close";
    RegisterEventAction["EDIT_PHONE"] = "Phone edit";
    RegisterEventAction["RESEND_CODE"] = "Resend code";
    RegisterEventAction["RESEND_EMAIL"] = "Resend email";
    RegisterEventAction["ATTEMPT"] = "Attempt";
    RegisterEventAction["ACCEPTED"] = "Accepted";
    RegisterEventAction["CONFIRMED"] = "NRC";
})(RegisterEventAction = exports.RegisterEventAction || (exports.RegisterEventAction = {}));
/*
 * Deposits
 */
var DepositEventAction;
(function (DepositEventAction) {
    DepositEventAction["OPEN"] = "Open";
    DepositEventAction["STARTED"] = "Started";
    DepositEventAction["ATTEMPT"] = "Attempt";
    DepositEventAction["DEPOSIT"] = "DC";
    DepositEventAction["ERROR"] = "Error";
    DepositEventAction["FTD"] = "FTD";
    DepositEventAction["NDC"] = "NDC";
})(DepositEventAction = exports.DepositEventAction || (exports.DepositEventAction = {}));
/*
 * Withdrawals
 */
var WithdrawalEventAction;
(function (WithdrawalEventAction) {
    WithdrawalEventAction["OPEN"] = "Open";
    WithdrawalEventAction["STARTED"] = "Started";
    WithdrawalEventAction["ATTEMPT"] = "Attempt";
    WithdrawalEventAction["WITHDRAW"] = "Success";
    WithdrawalEventAction["ERROR"] = "Error";
})(WithdrawalEventAction = exports.WithdrawalEventAction || (exports.WithdrawalEventAction = {}));
/*
 * Quick Deposit
 */
var QuickDepositEventAction;
(function (QuickDepositEventAction) {
    QuickDepositEventAction["INTENT"] = "Intent";
    QuickDepositEventAction["ATTEMPT"] = "Attempt";
    QuickDepositEventAction["SUCCESS"] = "Success";
    QuickDepositEventAction["ERROR"] = "Error";
})(QuickDepositEventAction = exports.QuickDepositEventAction || (exports.QuickDepositEventAction = {}));
var SeasonalEventAction;
(function (SeasonalEventAction) {
    SeasonalEventAction["GIFT_SELECTED"] = "Gift Selected";
    SeasonalEventAction["CLOSE"] = "Close";
    SeasonalEventAction["CTA"] = "View more details";
})(SeasonalEventAction = exports.SeasonalEventAction || (exports.SeasonalEventAction = {}));
var MembershipRegistrationEventAction;
(function (MembershipRegistrationEventAction) {
    MembershipRegistrationEventAction["ACCEPTED"] = "Accepted";
    MembershipRegistrationEventAction["ATTEMPT"] = "Attempt";
    MembershipRegistrationEventAction["CLOSE"] = "Close";
    MembershipRegistrationEventAction["SUBMIT"] = "Submit";
})(MembershipRegistrationEventAction = exports.MembershipRegistrationEventAction || (exports.MembershipRegistrationEventAction = {}));
